<template>
  <b-sidebar
    id="add-new-hs-code-sidebar"
    :visible="isAddNewHSCodeSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-h-s-code-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Add New HS Code</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <div class="p-2">
        <HSCodeForm :form-data.sync="formData" :loading="isSubmitting" @submit="onSubmit" />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BFormInvalidFeedback,
  BButton,
  BOverlay,
  BSpinner,
} from 'bootstrap-vue';
import { ref, computed } from '@vue/composition-api';
import Ripple from 'vue-ripple-directive';
import store from '@/store';
import HSCodeForm from './HSCodeForm.vue';

export default {
  name: 'HSCodeListAddNew',
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormInvalidFeedback,
    BButton,
    BOverlay,
    BSpinner,

    // Custom Components
    HSCodeForm,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewHSCodeSidebarActive',
    event: 'update:is-add-new-h-s-code-sidebar-active',
  },
  props: {
    isAddNewHSCodeSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const businessID = computed(() => store.state.user.businessID);
    const userID = computed(() => store.state.user.userID);

    // Loading state
    const isSubmitting = ref(false);
    const formData = ref(null);

    const resetForm = () => {
      formData.value = null;
    };

    const onSubmit = async () => {
      console.log('=== HS Code Add New On Submit', JSON.stringify(formData.value, null, 2));

      isSubmitting.value = true;

      try {
        formData.value.businessID = businessID.value;
        formData.value.userID = userID.value;

        await store.dispatch('fbr-invoice-hs-code/addHSCode', formData.value);

        // Show success toast
        store.dispatch('app/showToast', {
          title: 'Success',
          text: 'HS Code added successfully',
          variant: 'success',
        });

        emit('refetch-data');
        emit('update:is-add-new-h-s-code-sidebar-active', false);
      } catch (error) {
        console.error('Error adding HS code:', error);

        // Show user-friendly error message
        let errorMessage = 'Error adding HS code. Please try again.';

        if (error.message && error.message.includes('User ID not found')) {
          errorMessage = 'Session expired. Please login again.';
        } else if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        // Show error toast
        store.dispatch('app/showToast', {
          title: 'Error',
          text: errorMessage,
          variant: 'danger',
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      formData,
      onSubmit,
      isSubmitting,
      resetForm,
    };
  },
};
</script>

<style lang="scss" scoped>
#add-new-hs-code-sidebar {
  .content-sidebar-header {
    padding: 1rem 1.5rem !important;
  }
}
</style>
